import _get from 'lodash/get';

import { Google, GoogleTransformers, Pixall } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById, isVDP } from '@/analytics/utilities';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;
/**
 * @summary Sends Pixall and Google click for additional protections info on vdp
 */
export async function inventoryProtectionViewMoreClick(metadata, option) {
    const {
        data = {},
        dataLayer = {},
        state,
    } = metadata;

    const { inventoryId } = data;
    const pageName = _get(dataLayer, 'page.pageName', '');
    const inheritPageData = !['vdp'].includes(pageName);
    const inventory = getInventoryOwnerById(state, inventoryId);
    const vehicleData = googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }, inheritPageData);

    const element = `vdp_${data?.listingType.toLowerCase()}`;
    const eventData = {
        vehicle: { ...vehicleData },
    };

    const cmp = 'cta::view-more-information::additional-protections';

    Google.sendClickEvent({
        eventElement: element,
        eventResult: cmp,
        eventData,
    }, option);

    Pixall.sendClickEvent({
        eventSource: 'application',
        inventory,
        label: 'cta::explore-vehicle-protection-options::additional-protections',
        pixallData: {
            clickTypeToListingType: isVDP(dataLayer),
        },
    }, dataLayer, option);

    return { cmp, element };
}
